/* Version: 3.5.149 */
'use client';
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';
import { useRef, useEffect, useMemo } from 'react';
import { useListBox, useOption } from 'react-aria';
import OptionContext from './OptionContext.js';
import { List, ListItem } from './styledComponents.js';
import { jsx } from 'react/jsx-runtime';
import useTheme from '../../hooks/useTheme.js';
import useId from '../../hooks/useId.js';

var ListBox = function ListBox(props) {
  var ref = useRef(null);
  var theme = useTheme();
  var _props$listBoxRef = props.listBoxRef,
    listBoxRef = _props$listBoxRef === undefined ? ref : _props$listBoxRef,
    menuStyle = props.menuStyle,
    minWidth = props.minWidth,
    state = props.state;
  var _useListBox = useListBox(props, state, listBoxRef),
    listBoxProps = _useListBox.listBoxProps;
  // NOTE: This is needed to keep `axe` happy
  var id = useId('listbox-');
  return /*#__PURE__*/jsx(List, _objectSpread(_objectSpread({}, listBoxProps), {}, {
    id: id,
    menuStyle: menuStyle,
    minWidth: minWidth,
    ref: listBoxRef,
    theme: theme,
    children: _toConsumableArray(state.collection).map(function (item) {
      return /*#__PURE__*/jsx(Option, {
        item: item,
        state: state
      }, item.key);
    })
  }));
};
var Option = function Option(_ref) {
  var item = _ref.item,
    minWidth = _ref.minWidth,
    state = _ref.state;
  var ref = useRef(null);
  var theme = useTheme();
  var _useOption = useOption({
      key: item.key
    }, state, ref),
    optionProps = _useOption.optionProps,
    labelProps = _useOption.labelProps,
    descriptionProps = _useOption.descriptionProps,
    isDisabled = _useOption.isDisabled,
    isSelected = _useOption.isSelected,
    isFocused = _useOption.isFocused;
  useEffect(function () {
    var _ref$current;
    // Workaround required for React Aria issue #1513:
    // https://github.com/adobe/react-spectrum/issues/1513#issuecomment-1641830053
    (_ref$current = ref.current) === null || _ref$current === undefined || _ref$current.addEventListener('touchend', function (event) {
      event.preventDefault();
    },
    // NOTE: this option is required to ensure consistent behaviour in all browsers
    // https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#using_passive_listeners
    {
      passive: false
    });
  }, []);

  // The Label and Description components will be used within an <Item>.
  // They receive props from the OptionContext.
  // This ensures that the option is ARIA labelled by the label, and
  // described by the description, which makes for better announcements
  // for screen reader users.
  // Reference (React Aria): https://codesandbox.io/s/sharp-sun-e3fgd
  var context = useMemo(function () {
    return {
      labelProps: labelProps,
      descriptionProps: descriptionProps
    };
  }, [labelProps, descriptionProps]);
  return /*#__PURE__*/jsx(ListItem, _objectSpread(_objectSpread({}, optionProps), {}, {
    "aria-disabled": isDisabled,
    "aria-selected": isSelected,
    "data-focused": isFocused,
    minWidth: minWidth,
    ref: ref,
    theme: theme,
    children: /*#__PURE__*/jsx(OptionContext.Provider, {
      value: context,
      children: item.rendered
    })
  }));
};

export { ListBox as default };
